module.exports = __webpack_public_path__ + "img/leftPanel.7da69d12.jpg";